import React from 'react';
import { NavLink } from 'react-router-dom';
import { TFunction } from 'i18next';
import _get from 'lodash/get';
import { Sector } from 'graphql-common';
import TextCell from '@lib/components/Table/commonComponents/TextCell/TextCell';
import ChipCell from '@lib/components/Table/commonComponents/ChipCell/ChipCell';
import { CellProps, Column } from '@lib/components/Table/types';
import { ChipTypes } from '@lib/components/Chip/Chip';
import CollapseCell from '@lib/components/Table/commonComponents/CollapseCell/CollapseCell';
import LinkComponent from '@lib/components/Link/Link';
import { APP_URLS } from 'constants/urls';

type ColumnsArgs = {
  onViewHandler: (v: Sector) => void;
  t: TFunction<'translation', undefined>;
};

export default function getTableColumns({ onViewHandler, t }: ColumnsArgs) {
  const result: Column<Sector>[] = [
    {
      id: 'code',
      Header: t('code'),
      accessor: 'code',
      Cell: (props: CellProps<Sector>) => <TextCell {...props} />,
      minWidth: 110,
      maxWidth: 110,
      width: 110,
      sortable: true,
    },
    {
      id: 'name',
      Header: t('name'),
      accessor: 'name',
      Cell: ({ item }: CellProps<Sector>) => {
        const label = _get(item, 'name');
        const type = _get(item, 'color', ChipTypes.chipWhite) as ChipTypes;
        if (!label || !type) return '-';
        return (
          <ChipCell
            label={label}
            type={type}
            leftIcon="circle"
            onClick={() => onViewHandler(item)}
          />
        );
      },
      maxWidth: 250,
      minWidth: 250,
      width: 250,
      sortable: true,
    },
    {
      id: 'sitesCount',
      Header: t('sites-total'),
      headerTooltipInfo: {
        tooltipBody: t('relevant-only-for-your-sites-desc'),
        icon: 'info',
        symbolsOutlined: true,
      },
      accessor: 'sitesCount',
      Cell: (props: CellProps<Sector>) => <TextCell {...props} />,
      sortable: true,
    },
    {
      id: 'linkedSites',
      Header: t('linked-sites'),
      headerTooltipInfo: {
        tooltipBody: t('relevant-only-for-your-sites-desc'),
        icon: 'info',
        symbolsOutlined: true,
      },
      accessorFn: ({ item }: CellProps<Sector>) => {
        const { sites } = item;
        return (sites?.collection || []).map(({ id, name }) => (
          <LinkComponent
            key={id}
            to={APP_URLS.dashboard.sites.view.getDynamicPath({
              pathParts: { id },
            })}
            component={NavLink}
          >
            {name}
          </LinkComponent>
        ));
      },
      Cell: (props: CellProps<Sector>) => (
        <CollapseCell {...props} minHeight={20} />
      ),
    },
  ];
  return result;
}
